import React from 'react';
import PropTypes from 'prop-types';
import { Accordion, Switch } from '@appcues/sonar';
import { FieldSet } from 'ext/components/ui';
import { EditorShape } from 'entities/step-groups/shape';
import { backdropTemplate } from 'entities/step-groups/templates/backdrop';
import { TRAIT_LABELS } from 'lib/trait/trait';
import { COLOR_MODES } from 'lib/user-preferences/user-preferences';
import { updateToThemed, EDITOR_MAPPING } from 'lib/themes/themes';
import ColorInput from 'components/ColorInput';
import useAccordionClick from './use-accordion-click';
import useStyleSettings from './use-style-settings';
import { Controls, GroupedField } from './styled';

export default function Backdrop({ editor, colorMode, onChange }) {
  const trackAccordion = useAccordionClick();
  const { backdrop, type } = editor || {};
  const traitLabel = TRAIT_LABELS[type];

  const handleBackdropShowChange = checked => {
    if (checked) {
      const diff = { backdrop: backdropTemplate.config };
      // If a theme is applied to the editor, that theme should be applied to the backdrop when it's re-added
      const themedDiff = updateToThemed({
        type: EDITOR_MAPPING,
        content: diff,
        selectedVariant: editor.style.theme,
      });
      onChange(themedDiff);
    } else {
      onChange(null, 'backdrop');
    }
  };

  const handleChange = patch => {
    onChange({ backdrop: patch });
  };

  const [valueFor, handleChangeFor] = useStyleSettings({
    onChange: handleChange,
    style: { ...backdrop },
    colorMode,
  });

  return (
    <Accordion.Item value="backdrop">
      <Accordion.Header>
        <Accordion.Trigger
          onClick={() => trackAccordion(traitLabel, 'Backdrop')}
        >
          Backdrop
        </Accordion.Trigger>
      </Accordion.Header>
      <Accordion.Content>
        <Controls>
          <FieldSet>
            <Switch
              id="show"
              checked={!!backdrop}
              onCheckedChange={handleBackdropShowChange}
              fullWidth
            >
              <Switch.Label htmlFor="show">Show</Switch.Label>
            </Switch>
          </FieldSet>

          {backdrop && (
            <FieldSet>
              <GroupedField>
                <ColorInput
                  id="backdrop-color"
                  label="Backdrop color"
                  color={valueFor.backgroundColor}
                  onChange={handleChangeFor.backgroundColor}
                />
              </GroupedField>
            </FieldSet>
          )}
        </Controls>
      </Accordion.Content>
    </Accordion.Item>
  );
}

Backdrop.propTypes = {
  editor: EditorShape,
  colorMode: PropTypes.oneOf(COLOR_MODES),
  onChange: PropTypes.func,
};
